'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _connectedDraggable = require('./connected-draggable');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_connectedDraggable).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/view/draggable/index.js
// module id = 3264
// module chunks = 0